module.exports = __webpack_public_path__ + "static/img/LOGO.bfd00f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO.jpg
// module id = 9w6V
// module chunks = 2